import api from 'plugin/api';
import { API_URL } from 'types/const';

/**
 * 상위 카테고리에 속한 하위 카테고리 목록 조회
 * @param {Object} params 요청 데이터
 * @param {string} params.ctgryGroupCd 상위 카테고리
 * @return {Object} 응답 데이터
 */
async function requestList(params) {
  return api.get(API_URL.category, { params });
}

export { requestList };
